import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { isLearnerSeatCutoverEnabled, resolveCutover } from "@/lib/featureFlags/learnerSeatCutover";

/** Server-controlled cutover. Any error/loading resolves to OFF (legacy path). */
export function useLearnerSeatCutover() {
  const env = import.meta.env.DEV === true && isLearnerSeatCutoverEnabled();
  const q = useQuery({
    queryKey: ["learner-seat-cutover"],
    staleTime: 60_000,
    enabled: !env,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("learner_seat_cutover_enabled");
      if (error) return false;
      return data === true;
    },
  });
  return { enabled: resolveCutover({ env, server: q.data ?? null }), loading: !env && q.isLoading };
}
